"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAddBasicOfferHintError = void 0;
var _logger = require("@ori/logger");
var _react = require("react");
var _utils = require("../utils");
/**
 * Failed apply offer response callback definition for BasicOfferHint.
 * Displays error for the user via triggerng show-error-notification custom event.
 * Setting availability & hiding unfullfillable offers is not solved for basic
 * offer hints so far.
 */ const useAddBasicOfferHintError = ()=>{
    const logger = (0, _logger.useLogger)('useAddBasicOfferHintError');
    const onAddOfferFailedCallback = (0, _react.useCallback)((response, otherError)=>{
        if (response) {
            // show specific error
            const { message: serverError } = response;
            const message = (0, _utils.getErrorTranslationId)(serverError);
            (0, _utils.showErrorNotification)(message);
        } else {
            // in other cases just display the generic error
            (0, _utils.showErrorNotification)();
            const error = new Error('Error while adding basket offer');
            logger.error(error, {
                otherError: String(otherError)
            });
        }
    }, [
        logger
    ]);
    return onAddOfferFailedCallback;
};
exports.useAddBasicOfferHintError = useAddBasicOfferHintError;
